import {Routes} from '@angular/router';

export const partnerCashRoutes: Routes = [
  {
    path: 'partner.cash',
    loadComponent: () => import('./partner.cash.component').then(m => m.PartnerCashComponent),
    data: {title: '方案兑付'},
    children:[
      {
        path: '',
        loadComponent: () => import('./cash.order/cash.order.component').then(m => m.CashOrderComponent),
      },
      {
        path: 'add.equity.cash',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '方案兑付明细' },
      },
      {
        path: 'add.equity.cash/:orderId',
        loadComponent: () => import('./add.equity.cash/add.equity.cash.component').then(m => m.AddEquityCashComponent),
        data: { title: '方案兑付明细' },
      },
    ]
  },
]
